import {scopedHandler} from 'utils/redux';
import ns from './namespace';
import initState from './state';
import * as actions from './actions';
import * as effects from './effects';
import {decorateHandler as lifecycle} from 'fragments/lifecycle';

const handler = scopedHandler(ns, (state = initState, fullState, {type, payload}) => {
	switch (type) {
		case actions.initialize.type: {
			return [state, effects.initialize()];
		}

		case actions.destroy.type: {
			return [initState, null];
		}

		case actions.navigateTo.type: {
			return [state, effects.navigateTo(payload)];
		}

		case actions.createLead.type: {
			return [state, effects.createLead()];
		}

		case actions.editLead.type: {
			return [state, effects.editLead(payload)];
		}

		case actions._initialize.type: {
			return [{...state, initialized: true}, null];
		}

		default:
			return [state, null];
	}
});

export default lifecycle({
	namespace: ns,
	initializeType: actions.initialize.type,
	destroyType: actions.destroy.type,
})(handler);
